<template>
  <div>
    <v-app-bar app color="#222222" dark>
      <div class="d-flex align-center">
        <v-img
          alt="TCDC_LOGO"
          class="shrink ml-3"
          contain
          src="@/assets/TCDC_Logo_White.png"
          transition="scale-transition"
          width="100"
        />
      </div>
      <v-spacer></v-spacer>
      <template v-if="isLogin">
        <v-avatar size="35" color="aliceblue">
            <template v-if="userDetail">
                <img
                        :src="userDetail.profile_image"
                        width="100%"
                >
            </template>
            <template v-else>
                <v-icon dark >mdi-account-circle</v-icon>
            </template>
        </v-avatar>
        <div style="color: aliceblue ; font-size: 16px; padding-left: 10px">{{userDetail.firstname}} {{userDetail.lastname}}</div>
      </template>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <a style="padding-left: 20px;" @click="onLogout" v-if="userDetail"
                   v-bind="attrs"
                   v-on="on">
                    <!--        <label>Logout</label>&nbsp;&nbsp;&nbsp;-->
                    <v-icon>fas fa-power-off</v-icon>
                </a>
            </template>
            <span>Logout</span>
        </v-tooltip>
    </v-app-bar>
  </div>
</template>
<script>
import {mapState} from "vuex";
import store from "../../store";

export default {
  name: "HeaderBar",
  computed: {
    ...mapState({
        isLogin: state => {
            return state.Login.isLogin;
        },
        token: state => {
            return state.Login.token;
        },
        userDetail: state => {
            return state.Login.userDetail;
        }
    }),
  },
  data(){
    return{
      items : ['Logout']
    }
  },
    watch:{
      userDetail: function (val) {
          console.log('watch', val);
      }
    },
  methods:{
    onLogout(){
      console.log(this.token);
      this.$store.dispatch("Login/onUserLogOut",this.token)
    }
  }
};
</script>

<style scoped></style>
